import { INestedVenueCategory } from 'src/api/getVenueCategories/types';
import { ITableCategory } from '../../types';
import { collectBranchVenueIds } from '../collectBranchVenueIds';

// this row is used to render a mini form in the venue categories table
const createRow = {
  isCreateRow: true,
  category_id: '',
  subCategoriesCount: 0,
  venuesAssignedCount: 0,
  isUncategorised: false,
  children: [],
  name: '',
  parent_category_id: null,
  display_order: 0,
  venue_ids: [],
  upDisplayOrder: 0,
  downDisplayOrder: 0,
  rolledUpVenuesCount: undefined,
};
/**
 * Recursively maps nested venue categories to table data format
 * Computes upDisplayOrder and downDisplayOrder for each category based on sibling positions,
 * along with a rolled up venue count for categories that have sub-categories
 * @param {INestedVenueCategory[]} categories - Nested array of venue categories
 * @param {boolean} createOpen - Whether the create category mini form should be returned
 * @param {string | null} parentCategoryId - The parent category id that the create category mini form should belong to
 * @returns {ITableCategory[]} - Array of categories formatted for table display
 */
export const mapCategoriesToTableData = (
  categories: INestedVenueCategory[],
  createOpen: boolean,
  parentCategoryId: string | null,
): ITableCategory[] => {
  const mapCategory = (
    category: INestedVenueCategory,
    index: number,
    siblings: INestedVenueCategory[],
  ): ITableCategory => {
    const subCategoriesCount = category.children.length;
    const venueCount = category.venue_ids.length;
    const isUncategorised = category.category_id === null;
    const previousSibling = siblings[index - 1];
    // Disable move-up if previous sibling is uncategorised
    const upDisplayOrder = previousSibling?.category_id === null ? undefined : previousSibling?.display_order;

    const children: ITableCategory[] = [];
    for (let i = 0; i < category.children.length; i += 1) {
      children.push(mapCategory(category.children[i], i, category.children));
    }
    if (createOpen && parentCategoryId === category.category_id) children.push(createRow);

    return {
      ...category,
      subCategoriesCount: isUncategorised ? '-' : subCategoriesCount,
      venuesAssignedCount: venueCount,
      rolledUpVenuesCount: subCategoriesCount > 0 ? collectBranchVenueIds(category).length : undefined,
      upDisplayOrder,
      downDisplayOrder: siblings[index + 1]?.display_order,
      isUncategorised,
      children,
      isCreateRow: false,
    };
  };

  const allCategories: ITableCategory[] = [];
  for (let i = 0; i < categories.length; i += 1) {
    allCategories.push(mapCategory(categories[i], i, categories));
  }

  if (createOpen && parentCategoryId === null) {
    allCategories.push(createRow);
  }

  return allCategories;
};
